module.exports = __webpack_public_path__ + "ae9563d3d62bb0bc2dda7fa2b422b3be.png";